import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToPlayRejection = (
    playRejection$: Observable<void>,
    volumeStore: IVolumeStore
): Subscription =>
    playRejection$
        .subscribe(() => {
            if (!volumeStore.value.isForceMuted) {
                volumeStore.actions.forceMute();
            }
        });

export default subscribeToPlayRejection;